import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CandidateSpreadsheet from './CandidateSpreadsheet';

export default function SheetsWorkspace() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="sheets-standalone-workspace">
      <header className="border-b border-slate-200 px-4 sm:px-6 py-3 bg-white">
        <Link to="/dashboard" data-testid="sheets-return-dashboard" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-emerald-700">
          <ArrowLeft className="h-4 w-4" />Back to CRM
        </Link>
      </header>
      <main className="flex-1 min-w-0 min-h-0">
        <CandidateSpreadsheet standalone />
      </main>
    </div>
  );
}
